import 'react-dates/initialize';
require('react-dates/lib/css/_datepicker.css');

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DateRangePicker from 'react-dates/lib/components/DateRangePicker';

import { MainWrapper, OptionsWrapper } from './assets/styles';
import { defaultOptions, defaultStyles } from './assets/defaults';

export default class RangeDatePicker extends Component {
  static propTypes = {
    dates: PropTypes.object,
    onDatesChange: PropTypes.func
  };

  constructor(props) {
    super(props);

    let styles = {
      ...defaultStyles
    };

    if (props.styles) styles = { ...styles, ...props.styles };

    this.state = {
      styles,
      focusedInput: null,
      options: props.options || defaultOptions
    };
  }

  onFocusChange = focusedInput => this.setState({ focusedInput });

  onOptionPick = dates => {
    this.setState({ focusedInput: null });
    this.onDatesChange(dates);
  };

  onDatesChange = ({ startDate, endDate }) => {
    this.props.onDatesChange({
      from: startDate ? startDate.startOf('day') : startDate,
      to: endDate ? endDate.endOf('day') : endDate
    });
  };

  renderDateOptions = () => {
    const { styles, options } = this.state;

    return (
      <OptionsWrapper className="range-datepicker-options-wrapper" styles={styles}>
        {options.map(option => (
          <div
            className={`range-datepicker-option`}
            key={option.label}
            onClick={() =>
              this.onOptionPick({ startDate: option.startDate, endDate: option.endDate })
            }
          >
            {option.label}
          </div>
        ))}
      </OptionsWrapper>
    );
  };

  render() {
    const { dates, showOptions, datePickerOptions } = this.props;
    const { styles, focusedInput } = this.state;

    return (
      <MainWrapper className="range-datepicker-wrapper" styles={styles}>
        <img src={styles.calendarIcon} width={18} size={18} className="mr-2" />

        <DateRangePicker
          small
          readOnly
          startDate={dates.from}
          startDateId="startDateId"
          endDate={dates.to}
          endDateId="endDateId"
          onDatesChange={this.onDatesChange}
          focusedInput={focusedInput}
          onFocusChange={this.onFocusChange}
          displayFormat="DD/MM/YYYY"
          weekDayFormat="ddd"
          firstDayOfWeek={1}
          daySize={32}
          calendarInfoPosition="before"
          isOutsideRange={() => false}
          renderCalendarInfo={() => (showOptions ? this.renderDateOptions() : null)}
          {...datePickerOptions}
        />
      </MainWrapper>
    );
  }
}
